<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true" :ref="modalId">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-left">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h4 class="modal-title" >
            {{modalState}}&nbsp;&nbsp;
            <label class="badge bg-red" v-if="state == 3 && !editState && adjustInfo.is_mandatory">必選</label>
            <label class="badge bg-blue" v-if="state == 3 && !editState && adjustInfo.is_common">常見</label>
          </h4>
        </div>
        <div class="modal-body">
          <div class="text-right" style="margin-right: 10px;">
            <button class="btn btn-danger icon-modal-del" v-if="editState" @click="show.delNotify = !show.delNotify"><i class="fa fa-trash" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit" v-if="!editState && state == 3" @click.prevent="editState = true"><i class="fa fa-pencil" aria-hidden="true"></i></button>
            <button class="btn btn-primary icon-modal-edit" v-if="editState" @click.prevent="editState = false"><i class="fa fa-eye" aria-hidden="true"></i></button>
            <div v-if="show.delNotify" class="del-c-block">
              <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                  <div class="modal-header text-left">
                    <h4 class="modal-title">提醒</h4>
                  </div>
                  <div class="modal-body text-left">
                    <p>確定刪除此調整類別？</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-default" @click="show.delNotify = false">取消</button>
                    <button type="button" class="btn btn-danger" @click="delAdjust">刪除</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- info start-->
          <div class="box-body form" v-if="state == 3 && !editState">
            <div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">分類</span>
                  <div class="form-control form-info text-left">{{getSubType(adjustInfo.sub_type)}}</div>
                </div>
                <br />
              </div>
              <div class="input-group">
                <span class="input-group-addon">調整類別名稱</span>
                <div class="form-control form-info text-left">{{adjustInfo.name}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">排序</span>
                <div class="form-control form-info text-left">{{adjustInfo.sort}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">選擇項目個數</span>
                <div class="form-control form-info text-left">{{adjustInfo.min_limit}} ～ {{maxAmount(adjustInfo.max_limit)}}</div>
              </div>
              <br />
            </div>
            <div v-if="adjustInfo.price">
              <div class="input-group">
                <span class="input-group-addon">價格</span>
                <div class="form-control form-info text-left">{{adjustInfo.price}} ({{getPriceType(adjustInfo.price_type)}})</div>
              </div>
              <br />
            </div>
            <div v-if="adjustInfo.calorie">
              <div class="input-group">
                <span class="input-group-addon">熱量</span>
                <div class="form-control form-info text-left">{{adjustInfo.calorie}} cal</div>
              </div>
              <br />
            </div>
            <div v-if="adjustInfo.description">
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <div class="form-control form-info text-left">{{adjustInfo.description}}</div>
              </div>
              <br />
            </div>
            <div v-if="adjustInfo.remark">
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <div class="form-control form-info text-left">{{adjustInfo.remark}}</div>
              </div>
              <br />
            </div>
            <div v-if="adjustInfo.adjust_custom_id">
              <div class="input-group">
                <span class="input-group-addon">POS廠自定義的ID</span>
                <div class="form-control form-info text-left">{{adjustInfo.adjust_custom_id}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">調整類別更新時間</span>
                <div class="form-control form-info text-left">{{adjustInfo.update_time}}</div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">調整類別建立時間</span>
                <div class="form-control form-info text-left">{{adjustInfo.create_time}}</div>
              </div>
              <br />
            </div>
          </div>
          <!-- info end-->
          <!-- form start -->
          <div class="box-body form" v-if="state == 1 || editState">
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>分類</span>
                <div class="form-group">
                  <select class="form-control" v-model="adjustInfo.sub_type">
                    <option value="10">大小</option>
                    <option value="20">容器</option>
                    <option value="30">甜度</option>
                    <option value="40">溫度</option>
                    <option value="0">其他</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>調整類別名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.name" maxlength="32">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排序</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.sort" @keyup="veritySort" maxlength="4" v-if="state == 1" ref="sort1">
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.sort" @keyup="veritySort" maxlength="4" v-if="state == 3" ref="sort3">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>必選項目</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de;">
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" value="1" v-model="adjustInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="mandatoryRadio" value="0" v-model="adjustInfo.is_mandatory" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>常見價格</span>
                <div class="radio text-left h-38" style="border-left: 1px solid #d2d6de">
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" value="1" v-model="adjustInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">是</div>
                  </label>
                  <label class="m-l-15">
                    <input type="radio" name="commonRadio" value="0" v-model="adjustInfo.is_common" style="top: 12px;">
                    <div style="top: 8px; left: 8px;">否</div>
                  </label>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>最低選擇項目個數</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.min_limit" @keyup="verityMinLimit()" maxlength="9" v-if="state == 1" ref="minLimit1">
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.min_limit" @keyup="verityMinLimit()" maxlength="9" v-if="state == 3" ref="minLimit3">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>最高選擇項目個數</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.max_limit" @keyup="verityMaxLimit()" maxlength="9"  v-if="state == 1" ref="maxLimit1">
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.max_limit" @keyup="verityMaxLimit()" maxlength="9"  v-if="state == 3" ref="maxLimit3">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">價格</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.price" @keyup="verityPrice()" maxlength="9" v-if="state == 1" ref="price1">
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.price" @keyup="verityPrice()" maxlength="9" v-if="state == 3" ref="price3">
              </div>
              <div class="text-right text-15 text-red">(調整類別內的選項皆為此價格)</div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">價格類型</span>
                <div class="form-group">
                  <select class="form-control" v-model="adjustInfo.price_type" >
                    <option value="1">免稅價格</option>
                    <option value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <div class="text-right text-15 text-red">(若無價格則無須更動)</div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">熱量</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.calorie" @keyup="verityCalorie()" v-if="state == 1" ref="calorie1">
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.calorie" @keyup="verityCalorie()" v-if="state == 3" ref="calorie3">
              </div>
              <div class="text-right text-15 text-red">(調整類別內的選項皆為此熱量)</div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.remark" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">POS廠自定義的ID</span>
                <input class="form-control" placeholder="" type="text" v-model="adjustInfo.adjust_custom_id" maxlength="30">
              </div>
              <br />
            </div>
          </div>
          <!-- form end-->
        </div>
        <div class="modal-footer" v-if="state != 3 || editState">
          <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
          <button type="button" class="btn btn-primary" v-if="state == 1" @click="checkInputEmpty()">新增</button>
          <button type="button" class="btn btn-primary" v-if="editState" @click="checkInputEmpty()">編輯</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import $ from 'jquery'
export default {
  name: 'AdjustModal',
  props: {
    modalId: {
      type: String,
      required: true
    },
    // 1 = add, 2 = edit, 3 = info
    state: {
      type: Number
    },
    adjustId: {
      type: Number
    },
    adjustName: {
      type: String
    }
  },
  data () {
    return {
      editState: false,
      show: {
        delNotify: false
      },
      adjustInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    toggle () {
      $(this.$refs.infoAdjustModal).css('display')
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getSubType (type) {
      if (type === 10) {
        return '大小'
      } else if (type === 20) {
        return '容器'
      } else if (type === 30) {
        return '甜度'
      } else if (type === 40) {
        return '溫度'
      } else {
        return '其他'
      }
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    veritySort () {
      var e
      if (this.state === 1) e = $(this.$refs.sort1)
      else if (this.state === 3) e = $(this.$refs.sort3)
      this.adjustInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMinLimit () {
      var e
      if (this.state === 1) e = $(this.$refs.minLimit1)
      else if (this.state === 3) e = $(this.$refs.minLimit3)
      this.adjustInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMaxLimit () {
      var e
      if (this.state === 1) e = $(this.$refs.maxLimit1)
      else if (this.state === 3) e = $(this.$refs.maxLimit3)
      this.adjustInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPrice () {
      var e
      if (this.state === 1) e = $(this.$refs.price1)
      else if (this.state === 3) e = $(this.$refs.price3)
      this.adjustInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityCalorie () {
      var e
      if (this.state === 1) e = $(this.$refs.calorie1)
      else if (this.state === 3) e = $(this.$refs.calorie3)
      this.adjustInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getAdjustInfo () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/adjust/' + this.adjustId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.adjustInfo = response.data.adjust
        }
      })
    },
    checkInputEmpty () {
      if (!this.adjustInfo.sub_type && parseInt(this.adjustInfo.sub_type, 10) !== 0) {
        this.$notify({
          title: '提醒',
          text: '請選擇分類',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫調整類別名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.updateAdjust()
      }
    },
    updateAdjust () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/adjust'
      var data = {
        name: this.allInput.name,
        sort: this.allInput.sort,
        min_limit: this.allInput.min_limit,
        max_limit: this.allInput.max_limit,
        price: this.allInput.price,
        price_type: this.adjustInfo.price_type,
        sub_type: this.adjustInfo.sub_type,
        is_mandatory: this.adjustInfo.is_mandatory,
        is_common: this.adjustInfo.is_common
      }
      if (!data.price.length) data.price = null
      if (this.adjustId) data['adjust_id'] = this.adjustId
      if (this.allInput.calorie) data['calorie'] = this.allInput.calorie
      if (this.allInput.vendor_custom_id) data['vendor_custom_id'] = this.allInput.vendor_custom_id
      if (this.allInput.description) data['description'] = this.allInput.description
      if (this.allInput.remark) data['remark'] = this.allInput.remark
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功新增調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
          self.setUpAdjust(true)
        }
      })
    },
    delAdjust () {
      var self = this
      var url = 'brand/' + this.$route.params.brand_id + '/adjust?adjust_id=' + this.adjustId
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.editState = false
          var id = self.modalId
          $('#' + id).modal('toggle')
          self.setUpAdjust(true)
        }
      })
    },
    clearData () {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    }
  },
  computed: {
    ...mapGetters(['getModal']),
    modalState () {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name
      if (this.editState) return '編輯' + this.adjustInfo.name
      else return '新增調整類別'
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    allInput () {
      return {
        name: this.checkInput(this.adjustInfo.name),
        sort: this.checkInput(this.adjustInfo.sort),
        vendor_custom_id: this.checkInput(this.adjustInfo.adjust_custom_id),
        description: this.checkInput(this.adjustInfo.description),
        remark: this.checkInput(this.adjustInfo.remark),
        price: this.checkInput(this.adjustInfo.price),
        calorie: this.checkInput(this.adjustInfo.calorie),
        min_limit: this.checkInput(this.adjustInfo.min_limit),
        max_limit: this.checkInput(this.adjustInfo.max_limit)
      }
    }
  },
  mounted () {
    var self = this
    $('.modal').on('hidden.bs.modal', function () {
      self.setModal(false)
      self.clearData()
    })
  },
  watch: {
    getModal () {
      if (this.getModal) {
        this.$nextTick(function () {
          this.$set(this.adjustInfo, 'is_mandatory', '0')
          this.$set(this.adjustInfo, 'is_common', '0')
        })
        this.editState = false
        this.show.delNotify = false
        if (this.adjustId && this.state !== 1) {
          this.getAdjustInfo()
        }
      }
    }
  }
}
</script>
<style lang="sass">
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  input[type=checkbox], input[type=radio]
    margin: 0px
  .text-light-gray
    color: $light-gray !important
  .checkbox, .radio
    margin: 0px
  .m-l-15
    margin-left: 15px
</style>



// WEBPACK FOOTER //
// AdjustModal.vue?214f380c